export default __webpack_public_path__ + "static/1239-3c686b7f9c555214d6f279f043b9be2a.gif";